import { toast } from 'sonner';

export default function ProductCard({ product, setModalOpen, setProduct }) {
  const user = JSON.parse(localStorage.getItem('user'));

  const handleConfirm = () => {
    if (user.balance < product.price) {
      toast.error('Insufficient balance');
      return;
    }
    setProduct(product);
    setModalOpen(true);
  };

  return (
    <>
      <div
        className="
        relative group 
        rounded-2xl 
        overflow-hidden cursor-pointer
        border-[0.5px] border-[#292929] transition-all duration-200
        "
        onClick={handleConfirm}
      >
        <img
          alt=""
          className="w-full rounded-2xl h-full object-cover object-center group-hover:scale-110 duration-200"
          src={'/api/v2/image/resize?image=' + product.image + '&size=large'}
        />
        <div className="absolute p-4 pt-6 bottom-0 left-0 text-white bg-gradient-to-t w-full from-black from-10%">
          <div className="flex justify-between">
            <div className="flex flex-col">
              <p className="font-bold">{product.name}</p>
              <p className="text-sm">{product.description}</p>
            </div>
            <div className="flex items-center">
              <span
                className="
                px-2 py-1
              bg-indigo-500 rounded-full
                font-semibold text-xs 
                "
              >
                {product.price} 🪙
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
